import { render } from "./question-true-false-component.vue?vue&type=template&id=2fe2fdbe&ts=true"
import script from "./question-true-false-component.vue?vue&type=script&lang=ts"
export * from "./question-true-false-component.vue?vue&type=script&lang=ts"

import "./question-true-false-component.vue?vue&type=style&index=0&id=2fe2fdbe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__